<template>
  <MainLayout>
    <div 
      :class="theme === 'dark' ? 'tw-bg-[#151515] tw-text-gray-100' : 'tw-bg-gray-100 tw-text-gray-800'" 
      class="tw-min-h-screen tw-p-4 md:tw-p-8"
      :data-theme="theme"
    >
      <div class="tw-mb-6 md:tw-mb-8">
        <h1 :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-800'" class="tw-text-xl md:tw-text-2xl tw-font-bold">
          Relatório de Estação Meteorológica - {{ unidade.nome || 'Unidade' }}
        </h1>
      </div>

      <div class="tw-grid tw-grid-cols-1 tw-gap-6 md:tw-gap-8">
        <div 
          :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" 
          class="tw-rounded-2xl tw-p-5 md:tw-p-8 tw-shadow-2xl"
        >
          <div class="tw-flex tw-items-center tw-gap-4 tw-mb-6 md:tw-mb-8">
            <div :class="theme === 'dark' ? 'tw-bg-blue-500/10' : 'tw-bg-blue-50'" class="tw-p-3 tw-rounded-xl">
              <i class="fa-solid fa-filter tw-text-blue-500 tw-text-lg"></i>
            </div>
            <h2 :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-800'" class="tw-text-base md:tw-text-lg tw-font-bold">
              Filtros de Busca
            </h2>
          </div>

          <form @submit.prevent="gerarRelatorio(1)">
            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-4 md:tw-gap-6">
              <div class="tw-space-y-2">
                <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Período</label>
                <BaseSelect v-model="data_pre_definida" :options="periodoOptions" option-label="label" option-value="value" placeholder="Selecione um período" />
              </div>

              <div v-if="data_pre_definida === PERIODO_MANUAL" class="tw-space-y-2">
                <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Início</label>
                <input type="date" v-model="dataInicio" class="tw-custom-input tw-border-none" />
              </div>

              <div v-if="data_pre_definida === PERIODO_MANUAL" class="tw-space-y-2">
                <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Final</label>
                <input type="date" v-model="dataFinal" class="tw-custom-input tw-border-none" />
              </div>

              <div class="tw-space-y-2">
                <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Por Página</label>
                <BaseSelect v-model="per_page" :options="perPageOptions">
                  <template #option="{ option }">{{ option }} itens</template>
                  <template #value="{ selected }">{{ selected }} itens</template>
                </BaseSelect>
              </div>
            </div>

            <div class="tw-mt-8 tw-flex tw-flex-col-reverse md:tw-flex-row tw-justify-end tw-gap-3 md:tw-gap-4">
              <button 
                type="submit" 
                :disabled="loadingDados"
                class="tw-w-full md:tw-w-auto tw-px-8 tw-py-3 tw-rounded-xl tw-bg-green-600 tw-text-white tw-text-sm tw-font-bold hover:tw-bg-green-700 tw-shadow-lg tw-shadow-green-600/20 tw-outline-none disabled:tw-opacity-50 tw-border-none"
              >
                <span v-if="!loadingDados">Visualizar Estação</span>
                <span v-else class="tw-flex tw-items-center tw-justify-center tw-gap-2">
                    <svg class="tw-animate-spin tw-h-4 tw-w-4 tw-text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Buscando...
                </span>
              </button>
            </div>
          </form>
        </div>

        <div 
          :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" 
          class="tw-rounded-2xl tw-p-0 tw-shadow-2xl tw-overflow-hidden tw-relative tw-min-h-[300px]"
        >
          <div class="tw-p-5 md:tw-p-8 tw-border-b tw-border-gray-800/10 tw-flex tw-items-center tw-gap-4">
            <div :class="theme === 'dark' ? 'tw-bg-green-500/10' : 'tw-bg-green-50'" class="tw-p-3 tw-rounded-xl">
              <i class="fa-solid fa-file-invoice tw-text-green-500 tw-text-lg"></i>
            </div>
            <h2 :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-800'" class="tw-text-base md:tw-text-lg tw-font-bold">
              Relatório da Estação Meteorológica
            </h2>
          </div>

          <div>
            <div v-if="loadingDados" class="tw-absolute tw-inset-0 tw-z-10 tw-bg-inherit tw-flex tw-flex-col tw-items-center tw-justify-center">
                <svg class="tw-animate-spin tw-h-10 tw-w-10 tw-text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="tw-opacity-20" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="tw-opacity-100" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span class="tw-mt-4 tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-opacity-50">Coletando dados meteorológicos...</span>
            </div>
          </div>

          <div v-if="estacaoData && estacaoData.length > 0" :class="{'tw-opacity-20': loadingDados}" class="tw-hidden md:tw-block tw-overflow-x-auto">
            <table class="tw-w-full tw-text-left">
              <thead>
                <tr :class="theme === 'dark' ? 'tw-bg-black/20' : 'tw-bg-gray-50/50'">
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Data</th>
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Estação</th>
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Temp.</th>
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Umidade</th>
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Pluviômetro</th>
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Chuva</th>
                </tr>
              </thead>
              <tbody class="tw-divide-y tw-divide-gray-800/10">
                <tr v-for="(item, index) in estacaoData" :key="index" class="hover:tw-bg-black/5">
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-whitespace-nowrap">
                    <span :class="theme === 'dark' ? 'tw-text-gray-200' : 'tw-text-gray-800'" class="tw-text-sm tw-font-semibold">{{ dataParte(item.data) }}</span>
                    <span class="tw-text-sm tw-text-gray-500 tw-ml-2 tw-tabular-nums">{{ horaParte(item.data) }}</span>
                  </td>
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-sm tw-font-semibold">{{ item.estacao }}</td>
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-sm tw-whitespace-nowrap">
                    <span class="tw-flex tw-items-center tw-gap-1.5"><i class="fa-solid fa-temperature-half tw-text-orange-500"></i><span class="tw-font-semibold tw-tabular-nums">{{ item.temperatura }}°C</span></span>
                  </td>
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-sm tw-whitespace-nowrap">
                    <span class="tw-flex tw-items-center tw-gap-1.5"><i class="fa-solid fa-droplet tw-text-sky-500"></i><span class="tw-font-semibold tw-tabular-nums">{{ item.umidade }}%</span></span>
                  </td>
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-sm tw-whitespace-nowrap">
                    <span class="tw-flex tw-items-center tw-gap-1.5"><i class="fa-solid fa-cloud-rain tw-text-indigo-400"></i><span class="tw-font-semibold tw-tabular-nums">{{ item.pluviometro }} mm</span></span>
                  </td>
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4">
                    <span
                      :class="choveu(item)
                        ? (theme === 'dark' ? 'tw-bg-blue-500/15 tw-text-blue-400 tw-border-blue-500/30' : 'tw-bg-blue-50 tw-text-blue-700 tw-border-blue-200')
                        : (theme === 'dark' ? 'tw-bg-white/5 tw-text-gray-400 tw-border-white/10' : 'tw-bg-gray-100 tw-text-gray-500 tw-border-gray-200')"
                      class="tw-inline-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-rounded-lg tw-border tw-whitespace-nowrap"
                    >
                      <i :class="choveu(item) ? 'fa-solid fa-cloud-showers-heavy' : 'fa-solid fa-cloud tw-opacity-50'" class="tw-text-sm"></i>
                      <span class="tw-text-[11px] tw-font-bold tw-uppercase">{{ choveu(item) ? 'Chuva' : 'Sem chuva' }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="estacaoData && estacaoData.length > 0" :class="{'tw-opacity-20': loadingDados}" class="md:tw-hidden tw-divide-y tw-divide-gray-800/10">
            <div v-for="(item, index) in estacaoData" :key="'mob-'+index" class="tw-p-5 tw-space-y-3">
              <div class="tw-flex tw-justify-between tw-items-start tw-gap-3">
                <div>
                  <span :class="theme === 'dark' ? 'tw-text-gray-200' : 'tw-text-gray-800'" class="tw-text-sm tw-font-semibold">{{ dataParte(item.data) }}</span>
                  <span class="tw-text-sm tw-text-gray-500 tw-ml-1.5 tw-tabular-nums">{{ horaParte(item.data) }}</span>
                </div>
                <span
                  :class="choveu(item)
                        ? (theme === 'dark' ? 'tw-bg-blue-500/15 tw-text-blue-400 tw-border-blue-500/30' : 'tw-bg-blue-50 tw-text-blue-700 tw-border-blue-200')
                        : (theme === 'dark' ? 'tw-bg-white/5 tw-text-gray-400 tw-border-white/10' : 'tw-bg-gray-100 tw-text-gray-500 tw-border-gray-200')"
                  class="tw-shrink-0 tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2.5 tw-py-1 tw-rounded-lg tw-border"
                >
                  <i :class="choveu(item) ? 'fa-solid fa-cloud-showers-heavy' : 'fa-solid fa-cloud tw-opacity-50'" class="tw-text-xs"></i>
                  <span class="tw-text-[10px] tw-font-bold tw-uppercase">{{ choveu(item) ? 'Chuva' : 'Sem chuva' }}</span>
                </span>
              </div>
              <div v-if="item.estacao" class="tw-text-xs tw-font-bold tw-text-gray-400">{{ item.estacao }}</div>
              <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-text-sm">
                <span class="tw-flex tw-items-center tw-gap-1.5"><i class="fa-solid fa-temperature-half tw-text-orange-500"></i><span class="tw-font-semibold">{{ item.temperatura }}°C</span></span>
                <span class="tw-flex tw-items-center tw-gap-1.5"><i class="fa-solid fa-droplet tw-text-sky-500"></i><span class="tw-font-semibold">{{ item.umidade }}%</span></span>
                <span class="tw-flex tw-items-center tw-gap-1.5"><i class="fa-solid fa-cloud-rain tw-text-indigo-400"></i><span class="tw-font-semibold">{{ item.pluviometro }} mm</span></span>
              </div>
            </div>
          </div>

          <div v-if="!loadingDados && estacaoData && estacaoData.length > 0" class="tw-px-6 tw-py-6 tw-bg-black/5 tw-border-t tw-border-gray-800/10">
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-between tw-gap-4">
              <div class="tw-text-xs tw-font-medium tw-opacity-60">
                Mostrando <span class="tw-font-bold">{{ (pagination.current_page - 1) * per_page + 1 }}</span> a 
                <span class="tw-font-bold">{{ Math.min(pagination.current_page * per_page, pagination.total) }}</span> de 
                <span class="tw-font-bold">{{ pagination.total }}</span> resultados
              </div>

              <nav v-if="pagination.last_page > 1" class="tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-1">
                <button 
                  @click="gerarRelatorio(pagination.current_page - 1)"
                  :disabled="pagination.current_page === 1"
                  class="tw-w-9 tw-h-9 tw-flex tw-items-center tw-justify-center tw-rounded-lg hover:tw-bg-black/10 disabled:tw-opacity-10 tw-bg-transparent tw-text-inherit"
                >
                  <i class="fa-solid fa-chevron-left tw-text-[10px]"></i>
                </button>

                <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-1">
                  <button 
                    v-for="link in filteredPaginationLinks" 
                    :key="link.label"
                    @click="handlePaginationClick(link)"
                    :class="[
                      'tw-w-9 tw-h-9 tw-text-xs tw-font-bold tw-rounded-lg',
                      link.active ? 'tw-bg-green-600 tw-text-white tw-shadow-md tw-shadow-green-600/20' : 'tw-bg-transparent hover:tw-bg-black/10 tw-opacity-60'
                    ]"
                    v-html="link.label"
                  ></button>
                </div>

                <button 
                  @click="gerarRelatorio(pagination.current_page + 1)"
                  :disabled="pagination.current_page === pagination.last_page"
                  class="tw-w-9 tw-h-9 tw-flex tw-items-center tw-justify-center tw-rounded-lg hover:tw-bg-black/10 disabled:tw-opacity-10 tw-bg-transparent tw-text-inherit"
                >
                  <i class="fa-solid fa-chevron-right tw-text-[10px]"></i>
                </button>
              </nav>
            </div>
          </div>

          <div v-else-if="!loadingDados && (!estacaoData || estacaoData.length === 0)" class="tw-py-16 tw-text-center">
            <p class="tw-text-gray-500 tw-text-xs tw-font-medium tw-uppercase tw-tracking-widest tw-opacity-50">
              Nenhum dado encontrado para este período.
            </p>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
/* eslint-disable */
import MainLayout from "@/components/layouts/v2/MainLayout.vue";
import { useToast } from "vue-toastification";
import { mapState } from 'vuex';
import BaseSelect from "@/components/ui/v2/BaseSelect.vue";
import { PERIODO_MANUAL, PERIODO_OPTIONS, getDatasPeriodo, hojeLocal } from "@/utils/periodoRelatorio";

export default {
    name: 'RelatorioEstacao',
    components: { MainLayout, BaseSelect },
    data() {
        const today = hojeLocal();
        return {
            estacaoData: [],
            pagination: { current_page: 1, last_page: 1, total: 0, links: [] },
            perPageOptions: [10, 25, 50, 100],
            periodoOptions: PERIODO_OPTIONS,
            PERIODO_MANUAL,
            per_page: 10,
            dataInicio: today,
            dataFinal: today,
            data_pre_definida: PERIODO_MANUAL,
            loadingDados: false,
            toast: useToast()
        };
    },
    computed: {
        ...mapState({
            unidade: state => state.unidade.unidade || {},
            theme: state => state.ui.theme
        }),
        filteredPaginationLinks() {
            return this.pagination.links.filter(l => !isNaN(l.label) || l.label === '...');
        }
    },
    watch: {
        data_pre_definida() {
            this.aplicarPeriodo();
        },
        per_page() {
            if(this.estacaoData && this.estacaoData.length > 0) this.gerarRelatorio(1);
        }
    },
    methods: {
        aplicarPeriodo() {
            const datas = getDatasPeriodo(this.data_pre_definida);
            if (datas) {
                this.dataInicio = datas.dataInicio;
                this.dataFinal = datas.dataFinal;
            }
        },
        async gerarRelatorio(page = 1) {
            this.aplicarPeriodo();
            this.loadingDados = true;
            try {
                const unidadeId = this.$route.params.unidade || this.unidade.id;
                const response = await this.$store.dispatch("estacao/fetchEstacaoDataRelatorio", {
                    unidadeId, 
                    dataInicio: this.dataInicio, 
                    dataFim: this.dataFinal,
                    page,
                    per_page: this.per_page
                });
                
                // Validação segura da estrutura paginada
                if (response && response.data) {
                    this.estacaoData = response.data;
                    this.pagination = {
                        current_page: response.current_page || 1,
                        last_page: response.last_page || 1,
                        total: response.total || 0,
                        links: response.links || []
                    };
                } else {
                    this.estacaoData = [];
                }
            } catch (error) {
                this.toast.error("Erro ao carregar dados meteorológicos.");
                this.estacaoData = [];
            } finally {
                setTimeout(() => { this.loadingDados = false; }, 300);
            }
        },
        handlePaginationClick(link) {
            if (!link.url || link.active || link.label === '...') return;
            const url = new URL(link.url);
            this.gerarRelatorio(url.searchParams.get('page'));
        },
        dataFormatadaLonga(data) {
            return new Date(data).toLocaleString("pt-BR");
        },
        dataParte(data) {
            const d = new Date(data);
            return isNaN(d) ? String(data || '') : d.toLocaleDateString("pt-BR");
        },
        horaParte(data) {
            const d = new Date(data);
            return isNaN(d) ? '' : d.toLocaleTimeString("pt-BR");
        },
        choveu(item) {
            return item.chuva === 'Sim' || item.chuva == 1;
        }
    },
};
</script>

<style scoped>
.tw-custom-input {
    @apply tw-w-full tw-rounded-xl tw-h-11 tw-p-3 tw-text-sm tw-outline-none;
}

[data-theme="dark"] .tw-custom-input {
    background-color: rgba(39, 43, 47, 0.35);
    color: #f3f4f6;
}

[data-theme="light"] .tw-custom-input {
    background-color: #f3f4f6;
    color: #1f2937;
}

::-webkit-scrollbar { width: 4px; }
::-webkit-scrollbar-thumb { background: #33b35a; border-radius: 10px; }

</style>